import CLIENT_ID_ONLINE from '../constants/rootConstants';
import { getHomeApiUrl } from '../selectors/getBaseUrlSelectors';

export default {
  fetch: (id, action, state) => ({
    url: `${getHomeApiUrl(state)}/travel/home/v1/tls/benefits/eligibility`,
    opts: {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        clientId: CLIENT_ID_ONLINE,
      },
    },
  }),
};
